import * as React from 'react';
import { ComplexValue, ElementLoader, InfoText, SelectSingle } from 'ui';
import { ChooseChartType } from './choose-chart-type';
import { AttributesPicker } from './attributes';
import { LayoutType } from '../types-store';
import styles from '../../../selection-report.scss';
import { Value } from 'app/types-shared';

interface ReportAreaComponentProps {
  fetchingExecute: boolean;
  layoutTypes: LayoutType[];
  selectedLayoutType?: number;
  presentationType: number;
  layoutAttributes: { [key: string]: string | boolean };
  numberOfGroupByFields: number;
  translation: any;
  onSetLayoutType: (type: Value) => void;
  onAttributeChange: (value: { [key: string]: string | boolean | number}[]) => void;
  children?: React.ReactNode;
  fetchingOptionsDrillDownTo?: boolean;
  optionsDrillDownTo?: ComplexValue<number>[];
  drillDownReport?: ComplexValue<number>;
  setDrillDownReport?: (drillDownReport: ComplexValue<number>) => void;
  onLoadDrillDownOptions?: () => void;
}

class ReportAreaComponent extends React.Component<ReportAreaComponentProps> {
  public render(): JSX.Element {
    const { fetchingOptionsDrillDownTo, optionsDrillDownTo, translation, 
      drillDownReport, setDrillDownReport, onLoadDrillDownOptions } = this.props;

    return (<div className={`${styles.selectionReport} report-view`}>
      <ChooseChartType
        numberOfGroupByFields={this.props.numberOfGroupByFields}
        selectedLayoutType={this.props.selectedLayoutType}
        layoutTypes={this.props.layoutTypes}
        onSetLayoutType={this.props.onSetLayoutType}
        translations={translation}
      />
      <div className={styles.drilldownToWrapper}>
        <span className={styles.outerLabel}>{translation?.drill_down_to}
          <InfoText className={styles.infoTextWrapper} visible={true} text={translation.drill_down_to_info} />
        </span>
        <SelectSingle
          componentId={'drill-down-to'}
          className={styles.drilldownTo}
          valueItem={drillDownReport}
          options={optionsDrillDownTo}
          onLoadOptions={onLoadDrillDownOptions}
          onChange={setDrillDownReport}
          textOptionsDone={translation?.drill_down_to_done}
          fetching={fetchingOptionsDrillDownTo}
        />
      </div>
      <AttributesPicker
        presentationType={this.props.presentationType}
        layoutAttributes={this.props.layoutAttributes}
        onAttributeChange={this.props.onAttributeChange}
        translations={translation}
        numberOfGroupByFields={this.props.numberOfGroupByFields}
      />
      {this.props.fetchingExecute
        ? <ElementLoader />
        : this.props.children}
    </div>);
  }
}

export const ReportArea = ReportAreaComponent;
